import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledLogo = styled.figure`
  path {
    fill: ${themeGet('color.colorGrayBlue60')};
    transition: fill 0.3s ease-out;
  }

  a:hover path {
    fill: ${themeGet('color.colorBlue')};
  }

  svg {
    max-width: 100%;
    height: auto;
    margin: 0;
    width: ${(props) => {
      switch (props.logo) {
        case 'uber':
          return '100px';
        case 'spotify':
        case 'glassdoor':
        case 'instacart':
          return '115px';
        default:
          return '90px';
      }
    }};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    svg {
      width: ${(props) => {
        switch (props.logo) {
          case 'uber':
            return '90px';
          case 'spotify':
            return '95px';
          case 'glassdoor':
          case 'instacart':
            return '115px';
          default:
            return '85px';
        }
      }};
    }
  }
`;

export const StyledLogos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  grid-column-gap: ${themeGet('scale.scaleUp08')};
  grid-row-gap: ${themeGet('scale.scaleUp05')};
  justify-content: center;

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: repeat(6, auto);
    justify-content: space-between;
    grid-column-gap: ${themeGet('scale.scaleUp02')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: ${themeGet('scale.scaleBase')};
    margin-bottom: -${themeGet('scale.scaleDown03')};
  }
`;

export const StyledCta = styled.div`
  margin-top: ${themeGet('scale.scaleUp05')};
`;
